import {isBrandPortal} from '@netx/core-cms-next/utils/isBrandPortal';
import {SearchTypeAdvancedRaw} from './advancedRaw/constants';
import {SearchTypeAttributeHistory} from './attributeHistory/constants';
import {SearchTypeCart} from './cart/constants';
import {SearchTypeCategoryId} from './categoryId/constants';
import {SearchTypeCheckouts} from './checkouts/constants';
import {SearchTypeContents} from './contents/constants';
import {SearchTypeCustom} from './custom/constants';
import {SearchTypeDate} from './date/constants';
import {SearchTypeExpiration} from './expiration/constants';
import {SearchTypeFileAspect} from './fileAspect/constants';
import {SearchTypeFileFormat} from './fileFormat/constants';
import {SearchTypeFileFormatFamily} from './fileFormatFamily/constants';
import {SearchTypeFileSize} from './fileSize/constants';
import {SearchTypeKeyword} from './keyword/constants';
import {SearchTypeMetadata} from './metadata/constants';
import {SearchTypeAI} from './ai/constants';
import {SearchTypeRelatedAssets} from './relatedAssets/constants';
import {SearchTypeSavedSearch} from './savedSearch/constants';
import {SearchTypeUser} from './user/constants';
import {SearchTypeVisual} from './visual/constants';

export enum SearchType {
	ACTIVE_TEMPLATES = 28 as const,
	ADVANCED_RAW = SearchTypeAdvancedRaw,
	ATTRIBUTE_HISTORY = SearchTypeAttributeHistory,
	BRANCH_CHILDREN = 15 as const,
	CART = SearchTypeCart,
	CATEGORY_ID = SearchTypeCategoryId,
	/** not used - see CATEGORY_ID */
	CATEGORY_NAME = 5 as const,
	CHECKOUTS = SearchTypeCheckouts,
	CONTENTS = SearchTypeContents,
	CUSTOM = SearchTypeCustom,
	DATE = SearchTypeDate,
	EXPIRE = SearchTypeExpiration,
	FILE_ASPECT = SearchTypeFileAspect,
	FILE_FORMAT = SearchTypeFileFormat,
	FILE_FORMAT_FAMILY = SearchTypeFileFormatFamily,
	FILE_SIZE = SearchTypeFileSize,
	FILE_STATUS = 25 as const,
	KEYWORD = SearchTypeKeyword,
	LAST_SEARCH = 12 as const,
	LOCATION = 20 as const,
	METADATA = SearchTypeMetadata,
	METADATA_HISTORY = 18 as const,
	AI = SearchTypeAI,
	PROOF = 21 as const,
	RATING = 19 as const,
	RELATED_ASSETS = SearchTypeRelatedAssets,
	REVIEWS = 16 as const,
	SAVED_SEARCH = SearchTypeSavedSearch,
	/** no longer a thing really but still there */
	THESAURUS = 14 as const,
	USER = SearchTypeUser,
	VISUAL = SearchTypeVisual,
}

// DAM-23532 - removing these from the portal (for now)
const OMIT_RULES_FOR_PORTAL = [
	SearchType.ADVANCED_RAW,
	SearchType.CATEGORY_ID,
	SearchType.CHECKOUTS,
	SearchType.USER,
];

export const EditableRuleTypes = [
	SearchType.ADVANCED_RAW,
	SearchType.CATEGORY_ID,
	SearchType.CHECKOUTS,
	SearchType.CONTENTS,
	SearchType.DATE,
	SearchType.FILE_ASPECT,
	SearchType.FILE_FORMAT,
	SearchType.FILE_FORMAT_FAMILY,
	SearchType.FILE_SIZE,
	SearchType.KEYWORD,
	SearchType.METADATA,
	SearchType.USER,
	SearchType.VISUAL,
].filter((type) => !isBrandPortal() || !OMIT_RULES_FOR_PORTAL.includes(type));
